/**
 * @fileoverview Model representing the server response after requesting verification methods
 *
 * @author Heesun Jun (hjun@yext.com)
 */
import {VerificationMethod} from '/src/com/yext/listingslaunchstorm/js/data/verificationmethod';

export class GetVerificationMethodsResponse {
  /**
   * @param {{
   *  methods: !Array<VerificationMethod>,
   *  phoneNumber: string,
   *  smsNumber: string,
   *  emailUser: string,
   *  emailDomain: string,
   *  usernameEditable: boolean,
   *  addressTokens: Array<string>,
   * }} params
   */
  constructor(params) {
    /** @type {Array<VerificationMethod>} */
    this.methods = params.methods;
    /** @type {string} */
    this.phoneNumber = params.phoneNumber;
    /** @type {string} */
    this.smsNumber = params.smsNumber;
    /** @type {string} */
    this.emailUser = params.emailUser;
    /** @type {string} */
    this.emailDomain = params.emailDomain;
    /** @type {boolean} */
    this.usernameEditable = params.usernameEditable;
    /** @type {Array<string>} */
    this.addressTokens = params.addressTokens;
  }

  /**
   * @param {GetVerificationMethodsResponseJson} json
   * @return {!GetVerificationMethodsResponse}
   */
  static fromJSON(json) {
    return new GetVerificationMethodsResponse({
      methods: json['methods'],
      phoneNumber: json['phoneNumber'],
      smsNumber: json['smsNumber'],
      emailUser: json['emailUser'],
      emailDomain: json['emailDomain'],
      usernameEditable: json['usernameEditable'],
      addressTokens: json['addressTokens'],
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  methods: !Array<VerificationMethod>,
 * }}
 */
export var GetVerificationMethodsResponseJson;
